<template>
  <div>
    <p class="answer-text">
      Vastauksesi: {{ answers.filter((answer) => answer.correct).length }} /
      {{ correctLength }}
      oikein.
    </p>
    <ul class="answer-list">
      <li
        v-for="answer in answers"
        :key="answer.value"
        :class="answer.correct ? 'correct' : 'incorrect'"
      >
        {{ answer.text }}
      </li>
    </ul>
    <hr />
    <h3>{{ correct ? "Oikein!" : "Väärin!" }}</h3>
    <custom-paragraph
      class="explanation"
      :text="explanation.text"
      :link="explanation.link"
    />
  </div>
</template>

<script>
import CustomParagraph from "./CustomParagraph.vue";
export default {
  components: { CustomParagraph },
  props: ["answers", "correct", "correctLength", "explanation"],
};
</script>

<style scoped>
.answer-text {
  color: var(--quiz-text-color);
  margin: 25px 0;
}

.answer-list {
  margin: 10px 0;
  padding: 0 30px 16px 30px;
}

.correct {
  color: var(--quiz-correct-color);
}

.incorrect {
  color: var(--quiz-incorrect-color);
}

.explanation {
  color: var(--quiz-text-color);
  margin: 25px 0;
}

hr {
  margin-bottom: 25px;
}
</style>
